import * as React from 'react';
import { Typography, List, ListItem, ListItemText, ListItemIcon, Button, ListItemButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistoryVitals } from '../../../hooks/history/useHistoryVitals';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import { removeZeroDecimals } from '../../../utils/removeZeroDecimals';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import { getTempLevel } from '../../../utils/getTempLevel';
import { getPulseLevel } from '../../../utils/getPulseLevel';
import { getRespiratoryLevel } from '../../../utils/getRespiratoryLevel';
import VitalsForm from '../forms/VitalsForm';
import VitalsView from '../modals/VitalsView';

export default function LatestVitals({ pet = null, history = null, mode='pet', updateFlag }) {
  const { t } = useTranslation('common');

  const  {vitals, loading, loadMore, searchFunction, resetParent } = useHistoryVitals(null, null, pet?.id, mode, null, 1, 1);

  const [vitalsFormOpen, setVitalsFormOpen] = React.useState(false);
  const [vitalsViewOpen, setVitalsViewOpen] = React.useState(false);

  const [selectedVital, setSelectedVital] = React.useState(null);

  const onSaveHistorySuccess = () => {
    setVitalsFormOpen(false);
    resetParent();
  };
  
  React.useEffect(() => {
    if (vitals.data.length !== 0)
    {
      // setListEmpty(false);
    }
  }, [vitals]);

  React.useEffect(() => {
    if (!loading)
    {
      // if (setDoneLoading) setDoneLoading(true);
    }
  }, [loading]);

  React.useEffect(() => {
    resetParent();
  }, [updateFlag]);

  return (
    <>
      {loading ? (
        <></>
      ) : (
      vitals?.data.map((vital) => (
        <ListItem 
            key={"vitals" + vital.id}
            sx={{ py: 0 }}
            alignItems="flex-start"
            onClick={() => {
              setSelectedVital(vital);
              setVitalsViewOpen(true);
            }}
        >
            
            <ListItemText
              primary={
                <>
                <Typography component="span" variant="body2" sx={{ maxWidth: '90%' }}>
                  {`${vital.weight ? "W" + removeZeroDecimals(vital.weight) : ""} `}
                </Typography>
                {vital.temp > 0 ?
                <Typography color={getTempLevel(vital.temp, vital.pet.species_id)} component="span" variant="body2" sx={{ maxWidth: '90%' }}>
                  {`T${removeZeroDecimals(vital.temp)} `}
                </Typography>
                : null }
                {vital.pulse > 0 ?
                <Typography color={getPulseLevel(vital.pulse, vital.pet.species_id, vital.weight, vital.pet.birthdate)} component="span" variant="body2" sx={{ maxWidth: '90%' }}>
                  {`P${removeZeroDecimals(vital.pulse)} `}
                </Typography>
                : null }
                {vital.respiration > 0 ?
                <Typography color={getRespiratoryLevel(vital.respiration, vital.pet.species_id)} component="span" variant="body2" sx={{ maxWidth: '90%' }}>
                  {`R${removeZeroDecimals(vital.respiration)} `}
                </Typography>
                : null }
                </>
              }
            secondary={formatToLocalDateTime(vital.updatedAt)}
            />

        </ListItem>
      )))}
      <Button 
        fullWidth 
        variant="outlined" 
        color="primary" 
        onClick={() => setVitalsFormOpen(true)}
        startIcon={<MonitorHeartIcon />}
      >
        Update Vitals
      </Button>
      {vitalsFormOpen && (
        <VitalsForm
          open={vitalsFormOpen}
          onClose={() => setVitalsFormOpen(false)}
          pet={pet}
          history={history}
          mode="create"
          successCallback={onSaveHistorySuccess}
        />
      )}
      {vitals.data.length > 0 && (
      <VitalsView
        open={vitalsViewOpen}
        onClose={() => setVitalsViewOpen(false)}
        vitals={selectedVital}
      />
      )}
    </>
  );
}